// Module
var code = "<div class=\"ui basic segment\" ng-class=\"{loading : saml.loading}\"></div>";
// Exports
module.exports = code;